module.exports = __webpack_public_path__ + "aw.a8209356112ba74a0eea.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/aw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/aw.svg
// module chunks = styles